export const setAllReviews = (reviews) => ({
    type: "SET_ALLREVIEWS",
    reviews
})